import getParentState from '../selectors';
import { AppState } from 'state/types';

export default function getState(state: AppState) {
  return getParentState(state).ui;
}
